<template>
  <div id="wrapper">

    <side-menu></side-menu>

    <div id="page-wrapper" class="gray-bg">

      <nav-menu></nav-menu>

      <bread-crumps title='Usuários' action='Listagem' btnLink='/users/create' btnTxt='Incluir Usuário' />

      <div class="wrapper wrapper-content animated fadeIn">

        <spinner size="large" message="Aguarde..." v-if="showSpinner"></spinner>

        <div class="row">
          <div class="col-lg-12">
            <div class="ibox float-e-margins">

              <div class="ibox-title">
                <h5>Usuários</h5>
              </div>

              <div class="ibox-content" v-if="isPermited">

                <list-filter v-on:filter="onFilter" :attributes="searchableFields"></list-filter>

                <div class="panel panel-default" v-for="(user, idx) in list" v-bind:key="user.id">

                  <div class="panel-heading" data-toggle="collapse" data-parent="#accordion" :href="'#collapse' + user.id">
                    <h5 class="panel-title">
                      <span>{{ user.name }}</span>
                    </h5>
                  </div>

                  <div :id="'collapse'+ user.id" class="panel-collapse collapse">
                    <div class="panel-body row">

                      <div class="col-lg-1 col-sm-1 col-xs-12">
                        <img :alt="user.name" class="img-circle" :src="user.img || '/static/img/profile.jpg'" />
                      </div>

                      <div class="col-lg-9 col-sm-7 col-xs-12 info">

                        <span class="title">{{ user.name }}</span>
                        <span>{{ user.email }}</span>

                        <div class="user-companies">
                          <p>Empresas:</p>
                          <div v-if="user.companies">
                            <ul v-for="comp in user.companies" :key="comp.public_key">
                              <li @click="seeCompany(comp.public_key)">{{ comp.name }}</li>
                            </ul>
                          </div>
                          <div v-if="!user.companies || user.companies.length == 0">
                            <span>Usuário não está associado a nenhuma empresa!</span>
                          </div>
                        </div>

                      </div>

                      <div class="col-lg-2 col-sm-4 col-xs-12">
                        <button class="btn btn-white btn-w-m" @click="edit(user)"><i class="fa fa-pencil"></i> Editar </button>
                        <button class="btn btn-white btn-w-m" @click="editPermissions(user)"><i class="fa fa-check"></i> Permissões </button>
                        <confirm-delete-btn v-on:delete="remove(user, idx)" :id="idx" :btnStyle="'btn-w-m'" :text="`Deseja excluir o usuário ${user.name}?`"></confirm-delete-btn>
                      </div>

                    </div>
                  </div>

                </div>

                <pagination-links v-on:paginate="onPaginate" :more="more" :page="query.page"></pagination-links>

              </div>

              <div class="ibox-content text-center" v-if="!isPermited || list.length == 0">
                <h1>{{ emptyText }}</h1>
              </div>

            </div>
          </div>

        </div>

      </div>

      <page-footer></page-footer>

    </div>
  </div>
</template>

<script>

  import NavMenu from './layout/NavMenu'
  import SideMenu from './layout/SideMenu'
  import BreadCrumps from './layout/BreadCrumps'
  import PageFooter from './layout/PageFooter'
  import Spinner from './layout/Spinner'
  import ListFilter from './ListFilter'
  import PaginationLinks from './PaginationLinks'
  import ConfirmDeleteBtn from "./layout/ConfirmDeleteBtn"

  import { mapGetters } from 'vuex'
  import { httpService } from '../providers/http-service'

  import { toast } from '../mixins/toast'
  import { permissions } from '../mixins/permissions'

  export default {
    mixins: [ toast, permissions ],
    components: { NavMenu, SideMenu, BreadCrumps, PageFooter, ListFilter, PaginationLinks, ConfirmDeleteBtn, Spinner },
    data () {
      return {
        list: [],
        more: false,
        currentUser: {},
        showSpinner: false,
        emptyText: '',
        isPermited: true,
        query: { filter: '', page: 0, limit: 10 },
        searchableFields: [
          { value: 'name', label: 'nome' },
          { value: 'email', label: 'e-mail' }
        ]
      }
    },
    methods: {
      ...mapGetters(['getLoggedUser', 'getCompany']),

      getUsers() {
        this.checkPermissions('', '72cc27f26644651e5dbf72c4f9a22f35', 'Listar Usuários')
        .then((isPermited) => {
          if(isPermited) {
            this.showSpinner = true
            const comp_pk = this.getCompany().public_key
            httpService.getCompanyUsers(comp_pk, this.query).then((res) => {
              this.list.push(...res.data)
              if(this.list.length == 0) { this.emptyText = 'Nenhum Usuário Cadastrado' }

              /* Filtro para evitar que usuário de veja na lista de usuários e delete */
              this.list = this.list.filter((users) => {
                return users.public_key !== this.currentUser.id && users.public_key !== 'c55e07d2677d40550e4a5a392a4b14ef'
              })

              this.showSpinner = false
              this.more = res.data.length === this.query.limit
            }).catch((err) => {
              this.showSpinner = false
              this.show_toast('error', 'Erro', 'Não foi possível acessar o servidor, por favor tente mais tarde "'+err.message+'"!')
            })
          } else {
            this.emptyText = 'Sem permissão para listar usuários'
            this.isPermited = isPermited
          }
        })
      },

      onFilter(filter) {
        this.list = []
        this.query.page = 0
        this.query.filter = filter
        this.getUsers()
      },

      onPaginate(pagination) {
        this.query.page = pagination.page
        this.query.limit = pagination.limit
        this.getUsers()
      },

      edit(user) {
        this.checkPermissions('', '11d0632099c633b1dd73b9bac676a621', 'Editar Usuário')
        .then((isPermited) => {
          if(isPermited) this.$router.push({ path: '/users/create', query: user })
        })
      },

      editPermissions(user) {
        this.checkPermissions('', '729fc37cb039db91d8dd6f6960cd8c0d', 'Conceder Permissões')
        .then((isPermited) => {
          if(isPermited) this.$router.push({ path: '/users/permissions', query: user })
        })
      },

      remove(user, idx) {
        this.checkPermissions('', 'f901d8efe84b23cb63ff741ba3b76943', 'Excluir Usuário')
        .then((isPermited) => {
          if(isPermited) {
            httpService.deleteUser(user).then((res) => {
              this.show_toast('success', 'Sucesso', 'Usuário excluído com sucesso.')
              this.list.splice(idx, 1)
            }).catch((err) => {
              this.show_toast('error', 'Erro', 'Falha ao excluir usuário. "'+err.message+'"!')
            })
          }
        })
      },

      seeCompany(id) {
        this.checkPermissions('', '8a2fd41ee4b3be69484fb1114cc95341', 'Visualizar Esta Empresa')
        .then((isPermited) => {
          if(isPermited) {
            httpService.getCompanyById(id).then((res) => {
              if(res.status == 200) {
                this.$router.push({ path: '/company/create', query: res.data[0] })
              }
            }).catch((err) => {
              this.show_toast('error', 'Erro', 'Não foi possível acessar o servidor  "'+err.message+'"!')
            })
          }
        })
      },
    },

    mounted() {
      this.currentUser = this.getLoggedUser()
      this.getUsers()
    }
  }
</script>

<style scoped>
  .panel { margin-bottom: 5px; }
  .panel-body { padding-bottom: 10px; }
  .panel-heading { cursor: pointer; }
  .panel-heading.collapsed { border: none; }
  .info * { display: block; }
  .info .title { font-weight: 700; }
  div .user-companies p { font-weight: bold; margin: 8px 4px 0px 0px; }
  div .user-companies span { font-style: italic; color: #1a7bb9 }
  div .user-companies ul li:hover { cursor: pointer; color: #1a7bb9; text-decoration: underline;}
  img {
    width: 50px;
    min-height: 50px;
    max-height: auto;
  }
  @media (max-width: 767px) {
    .panel-body { text-align: center; }
  }
</style>



// WEBPACK FOOTER //
// src/components/UsersPage.vue